import React from 'react';
import { useTranslation } from 'react-i18next';
import { Inbox } from 'lucide-react';

export function Loading() {
  const { t } = useTranslation();
  return (
    <div className="row" style={{ gap: 12, padding: 40, justifyContent: 'center' }}>
      <span className="spin" /> <span className="muted">{t('comun.cargando')}</span>
    </div>
  );
}

export function EmptyState({ msg, children }) {
  const { t } = useTranslation();
  return (
    <div className="card stack" style={{ alignItems: 'center', textAlign: 'center', padding: 40 }} data-testid="empty-state">
      <Inbox size={34} strokeWidth={2} className="muted" />
      <p className="muted" style={{ margin: 0 }}>{msg || t('comun.vacio')}</p>
      {children}
    </div>
  );
}

export function StatusDot({ estado, label }) {
  const { t } = useTranslation();
  return (
    <span className="badge" data-testid={`estado-${estado}`}>
      <span className={`dot ${estado}`} />
      {label !== false ? t(`estados.${estado}`) : null}
    </span>
  );
}

export function Stat({ n, k, testid, extra }) {
  return (
    <div className="card stat" data-testid={testid} {...(extra || {})}>
      <div className="n">{n}</div>
      <div className="k">{k}</div>
    </div>
  );
}
